import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-home-latest',
  templateUrl: './home-latest.component.html',
  styleUrls: ['./home-latest.component.scss']
})

export class HomeLatestComponent {

}

@Component({
  selector: 'star-mentors-dialog',
  templateUrl: 'star-mentors.html',
})
export class StarMentorsDialog {
  constructor(
    public dialogRef: MatDialogRef<StarMentorsDialog>,
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  close(){
    this.dialogRef.close();
  }
}




@Component({
  selector: 'gallery-dialog',
  templateUrl: 'gallery.html',
})
export class GalleryDialog {
  selectedImg:any;
  constructor(
    public dialogRef: MatDialogRef<GalleryDialog>, @Inject(MAT_DIALOG_DATA) public data:any
  ) {
    this.selectedImg = this.data.images[this.data.index]
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  close(){
    this.dialogRef.close();
  }

  next(){
    if(this.data.index < this.data.images.length - 1){
      this.data.index = this.data.index + 1;
      this.selectedImg = this.data.images[this.data.index]
    }
  }

  prev(){
    if(this.data.index > 0){
      this.data.index = this.data.index - 1;
      this.selectedImg = this.data.images[this.data.index]
    }
  }

}